/**
 * @page profile store
 * @author
 * @Date 2018/7/2
 */

import Cookies from 'js-cookie';
import {
  observable,
  action,
  computed,
  configure,
  makeAutoObservable,
} from 'mobx';

import Page from '_common/constants/PageLink';
import profileService from '_common/service/profileService';
import Storage from '_common/utils/Storage';
import UTIL from '_common/utils/util';

configure({
  enforceActions: 'always',
});

export default class ProfileStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      profile: observable,
      got: observable,
      fetching: observable,
      isPerson: computed,
      setBalanceMenu: action,
      setKYCLevel: action,
      setKYCType: action,
      setEmail: action,
      setPhone: action,
      setNationality: action,
      setWithdrawLimit: action,
      setKycStatus: action,
      getProfile: action,
      getTaxationHandleConfig: action,
      updateProfileAfterCreateSuccess: action,
    });

    this.rootStore = rootStore;
  }

  // 个人中心加载状态
  profile = {
    brokerAdmin: false, // 券商账户标志
    currentIsSub: false, // 子账号标志
    danger: null, // 异常登录数据
    email: '',
    kycLevel: 0,
    nationality: '', // kyc国际
    nickName: '', // 昵称
    phone: '',
    realName: '', // kyc 真实姓名
    userType: 1, // kyc 用户类型
    lastLogin: null,
    eddStatus: 1,
    withdrawLimit: 0, // 用户设置最大额度
    /** kyc 地址状态 0:未邮寄 1:邮寄中 2:未激活 3:已激活 */
    addressStatus: 0,
    withdrawInfoDisabled: 0, // 出金・出庫情報編集不可、0:No、1:Yes
    /** 0表示kyc未通过，1表示已通过 */
    canReVerification: 0,
    loginPwdExist: 0, // 是否设置登录密码 0:未设置 1:已设置
    /** carf表格是否需要向用户展示 */
    carfRequired: false,
    /** carf表格是否已提交 */
    carfSubmitted: false,
  };

  /** 是否已经获取到个人中心信息 */
  got = false;

  /** 正在请求 */
  fetching = false;

  balanceMenu = [];

  jpWithdrawDetailVerifyMethods = [];

  setBalanceMenu(balanceMenu) {
    this.balanceMenu = balanceMenu;
  }

  get isPerson() {
    return this.profile.userType === 0;
  }

  setKYCLevel(kycLevel) {
    this.profile.kycLevel = kycLevel;
  }

  setKYCType(type) {
    this.profile.userType = type;
  }

  setEmail(email) {
    this.profile.email = email;
  }

  setPhone(phone) {
    this.profile.phone = phone;
  }

  setNationality(nationality) {
    this.profile.nationality = nationality;
    Cookies.set('kycNationality', nationality, { expires: 7 });
  }

  setWithdrawLimit(withdrawLimit) {
    this.profile.withdrawLimit = withdrawLimit;
  }

  setJpWithdrawDetailVerifyMethods(jpWithdrawDetailVerifyMethods) {
    this.jpWithdrawDetailVerifyMethods = jpWithdrawDetailVerifyMethods;
  }

  // 再kyc，设置kyc状态：0表示kyc未通过，1表示已通过
  setKycStatus = (kycStatus) => {
    this.profile.canReVerification = kycStatus;
  };

  setCarfSubmitted = (carfSubmitted) => {
    this.profile.carfSubmitted = carfSubmitted;
  };

  updateProfileAfterCreateSuccess = () => {
    this.profile = { ...this.profile, loginPwdExist: 1 };
  };

  // 获取个人信息
  getProfile() {
    // 正在请求
    this.fetching = true;
    // 展示loading
    // this.rootStore.loadingStore.showLoading();
    profileService
      .getProfile()
      .then(
        action((res) => {
          // this.rootStore.loadingStore.hideLoading();
          const { brokerAdmin, currentIsSub, danger, nationality, kycStatus } =
            res.data;

          this.profile = res.data;

          // 已经获取到数据
          this.got = true;
          // 请求完成
          this.fetching = false;
          Cookies.set('kycNationality', nationality, { expires: 7 });
          danger
            ? Storage.set('dangerLogin', danger)
            : Storage.remove('dangerLogin');
          // Storage.set('nickName', nickName);
          Storage.set('currentIsSub', currentIsSub ? 1 : 0);
          Storage.set('isBrokerAdmin', brokerAdmin ? 1 : 0);
          this.setKycStatus(kycStatus);
        })
      )
      .catch(
        action((result) => {
          this.fetching = false;
          // 隐藏loading
          // this.rootStore.loadingStore.hideLoading();
          this.rootStore.loadingStore.showErrorDialog(result.msg);
        })
      );
  }

  getTaxationHandleConfig() {
    profileService
      .getTaxationHandleConfig()
      .then(
        action((res) => {
          const enableTaxation = res.data;
          const balanceMenu = UTIL.deepCopy(this.balanceMenu);
          const reportList = balanceMenu[balanceMenu.length - 1]?.list;
          const haveCorporateTaxationAdjustment =
            reportList[reportList.length - 1]?.link ===
            Page.corporateTaxationAdjustment;
          if (
            enableTaxation === true &&
            haveCorporateTaxationAdjustment !== true
          ) {
            balanceMenu[balanceMenu.length - 1]?.list?.push({
              tag: 'corporateTaxationAdjustment',
              text: '期末時価評価課税の適応除外',
              link: Page.corporateTaxationAdjustment,
            });
          } else if (
            enableTaxation === false &&
            haveCorporateTaxationAdjustment === true
          ) {
            balanceMenu[balanceMenu.length - 1]?.list?.splice(-1, 1);
          }
          this.setBalanceMenu(balanceMenu);
        })
      )
      .catch(
        action((result) => {
          this.rootStore.loadingStore.showErrorDialog(result.msg);
        })
      );
  }
}
